export default "__VITE_ASSET__zdA5vbFR__"